import Toastify from 'toastify-js'

const toastifyFailSetting = {
  text: '',
  duration: 3000,
  newWindow: true,
  gravity: 'top',
  position: 'center',
  className: 'ln-toast ln-toast--error'
}

const toastifySuccessSetting = {
  text: '',
  duration: 3000,
  newWindow: true,
  gravity: 'top',
  position: 'center',
  className: 'ln-toast ln-toast--success'
}

const failMsg = (text) => {
  toastifyFailSetting.text = text
  Toastify(toastifyFailSetting).showToast()
}

const successMsg = (text) => {
  toastifySuccessSetting.text = text
  Toastify(toastifySuccessSetting).showToast()
}

export {
  failMsg,
  successMsg
}
